export default class NavigationBarControl {
  constructor (element, args) {
    let header = document.createElement('header')
    let h1 = document.createElement('h1')
    let span = document.createElement('span')
    span.innerHTML = args.title

    let addButton = (button) => {
      let a = document.createElement('a')
      let spanIcon = document.createElement('span')
      spanIcon.innerHTML = button.icon
      a.className = button.classes ? 'icon ' + button.classes : 'icon'
      a.onclick = button.onclick
      a.appendChild(spanIcon)
      h1.appendChild(a)
    }

    if (args.primaryButton) {
      addButton(args.primaryButton)
    }

    if (args.leftHandButtons) {
      args.leftHandButtons.forEach(addButton)
    }

    if (args.secondaryButton) {
      addButton(args.secondaryButton)
    }

    h1.appendChild(span)

    if (args.rightHandButtons) {
      args.rightHandButtons.forEach(addButton)
    }

    header.appendChild(h1)

    if (args.contextMenu) {
      let contextMenuElementButton = document.createElement('a')
      let contextMenuElementIcon = document.createElement('span')
      contextMenuElementIcon.innerHTML = '\ue116'
      let contextMenuElement = document.createElement('nav')
      contextMenuElement.className = 'contextMenu invisible'

      let closeContextMenu = () => {
        contextMenuElement.classList.add('invisible')
        removeEventListener('click', closeContextMenu, false)
      }

      let openContextMenu = (e) => {
        e.stopPropagation()
        contextMenuElement.classList.remove('invisible')
        addEventListener('click', closeContextMenu, false)
      }

      contextMenuElementButton.className = 'icon'
      contextMenuElementButton.onclick = openContextMenu
      contextMenuElementButton.appendChild(contextMenuElementIcon)

      args.contextMenu.forEach((item) => {
        let a = document.createElement('a')
        let spanIcon = document.createElement('span')
        spanIcon.innerHTML = item.icon
        a.className = 'icon'
        a.onclick = item.onclick
        a.innerHTML = item.label ? item.label : ''
        a.insertBefore(spanIcon, a.childNodes[0])
        contextMenuElement.appendChild(a)
      })

      h1.appendChild(contextMenuElementButton)
      header.appendChild(contextMenuElement)
    }

    let fragment = document.createDocumentFragment()
    fragment.appendChild(header)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/NavigationBarControl.js